import log from 'loglevel';
import { TriggerManager } from '../../trigger-manager/trigger-manager';
import { OnsiteDisplayDeliveredEvent, OnsiteDisplayData, OnsiteDisplayClickedEvent } from './onsite-display.model';
import { CommandQueue } from '../../command-queue/command-queue';
import { DefaultResponseBody } from '../../browser-utilities/request-manager';
import { executeHtmlScripts } from '../../browser-utilities/execute-scripts';

/**
 * Will trigger an onSite display if enabled in configuration, request and displays are defined.
 * Onsite displays are HTML snippets that get inserted into Elements with the matching id selector.
 * They will trigger an event on display and another event when clicked.
 * @param responseBody
 */
export function onSiteDisplayListener(responseBody: DefaultResponseBody) {
  if (
    responseBody.onsiteEnabled &&
    responseBody.onsiteDisplays
  ) {
    OnSiteDisplayManager.triggerOnSiteDisplay(responseBody.onsiteDisplays);
  };
}

class OnSiteDisplayManager {
  static triggerOnSiteDisplay(displays: OnsiteDisplayData[]): void {
    if ((Array.isArray(displays) && !displays.length)) {
      log.error('Onsite Display: Format error:', displays);
      return;
    }
  
    log.debug('Onsite Displays triggered: ', displays);
  
    displays.forEach(({ elementId, body, campaignId, campaignName, channelConfigId, storyId }) => {
      let target = document.getElementById(elementId);
      if (!target) {
        log.warn(`Onsite Display: no element with elementID '${elementId}' found!`);
        return;
      }
  
      let handler = () => CommandQueue.add(() => TriggerManager.eventRequest<OnsiteDisplayClickedEvent>('track', {
        event: 'onsite-display.click',
        campaignId,
        campaignName,
        channelConfigId,
        storyId
      }));
  
      target.innerHTML = body;
      executeHtmlScripts(target);

      target.addEventListener('click', handler, false);
  
      CommandQueue.add(() => TriggerManager.eventRequest<OnsiteDisplayDeliveredEvent>('track', {
        event: 'onsite-display.impression',
        campaignId,
        campaignName,
        channelConfigId,
        storyId
      }));
    });
  }
}
